import T from 'prop-types';
import React, { useContext } from 'react';

const NavigationContext = React.createContext(null);

export const NavigationContextProvider = ({ navigateTo, ...rest }) => {
  if (window.Cypress || global.__DEV__) {
    window.navigateTo = navigateTo;
  }

  return <NavigationContext.Provider value={navigateTo} {...rest} />;
};

NavigationContextProvider.propTypes = {
  navigateTo: T.func,
};

export const useNavigationContext = () => useContext(NavigationContext);
